import React, { useRef, useState } from 'react'
import Modal from 'react-modal'
import { get } from 'lodash'
import api from '../../../../api'
import { useSelector } from 'react-redux'
import { message, Button as AntButton } from 'antd'
import ErrorModal from '../../ErrorModal'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		height: '90%',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		borderRadius: 15,
		border: 'none',
		overflowX: 'auto',
	},
	overlay: { background: '#00000099' },
}
const CustomInput = ({
	type,
	value,
	onChange,
	placeholder,
	onBlur,
	required,
}) => {
	return (
		<div className="flex flex-col w-full">
			{required && <span className="text-3xl -mb-3 text-red-500">*</span>}
			<input
				type={type}
				className={`border-[1px] border-[#DFE2E9] p-2 rounded-md w-full ${type === 'number' ? 'no-spinner' : ''}`}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				onBlur={onBlur}
			/>

			<style jsx>{`
				.no-spinner {
					-moz-appearance: textfield;
				}
				.no-spinner::-webkit-outer-spin-button,
				.no-spinner::-webkit-inner-spin-button {
					-webkit-appearance: none;
					margin: 0;
				}
			`}</style>
		</div>
	)
}

const CreateBlackListUser = ({ isOpen, onClose }) => {
	const { getMe } = useSelector((state) => state.main)
	const errorModalRef = useRef()
	const [isLoading, setIsLoading] = useState(false)
	const [name, setName] = useState('')
	const [surName, setSurName] = useState('')
	const [middleName, setMiddleName] = useState('')
	const [phoneNumber, setPhoneNumber] = useState('')
	const [passportSerial, setPassportSerial] = useState('')
	const [pinfl, setPinfl] = useState('')

	const handleCreate = () => {
		const data = {
			SalesPersonCode: getMe.SalesPersonCode || -1,
			CardName: `${surName} ${name} ${middleName}`,
			CardCode: pinfl,
			CardType: 'cCustomer',
			GroupCode: 102,
			Currency: '##',
			U_Created: get(getMe, 'EmployeeID', ''),
			U_Telephone: phoneNumber,
			U_pinfl: pinfl,
			U_PS: passportSerial,
		}

		setIsLoading(true)
		api
			.post(`BusinessPartners`, { ...data })
			.then(() => {
				onClose()
				message.success('Черный список клиент успешно создан')
			})
			.catch((err) => {
				errorModalRef.current?.open(JSON.parse(err.response.data).error.message)
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={onClose}
			style={customStyles}
			contentLabel="Create User Modal"
			ariaHideApp={false}
			shouldFocusAfterRender={false}
		>
			<div className="flex flex-col gap-5 w-[700px] p-8">
				<div className="flex flex-col gap-5">
					<p className="text-xl text-center font-bold text-blue-900">
						Создать черный список клиента
					</p>
					<div className="grid grid-cols-3 gap-2">
						<CustomInput
							type="text"
							value={surName}
							onChange={(e) => setSurName(e.target.value)}
							placeholder="Фамилия"
						/>
						<CustomInput
							type="text"
							value={name}
							onChange={(e) => setName(e.target.value)}
							placeholder="Имя"
						/>
						<CustomInput
							type="text"
							value={middleName}
							onChange={(e) => setMiddleName(e.target.value)}
							placeholder="Отчество"
						/>
					</div>
					<div className="w-full bg-black h-[1px] mt-2" />
				</div>

				<div className="flex flex-col gap-2">
					<div className="flex flex-row items-end gap-4">
						<CustomInput
							value={passportSerial}
							onChange={(e) => {
								if (e.target.value.length <= 9) {
									setPassportSerial(e.target.value)
								}
							}}
							type="text"
							placeholder="Пасспорт серия"
						/>
						<CustomInput
							value={pinfl}
							onChange={(e) => {
								if (e.target.value.length <= 14) {
									setPinfl(e.target.value)
								}
							}}
							type="number"
							placeholder="ПИНФЛ"
							required
						/>
					</div>
					<div>
						<CustomInput
							value={phoneNumber}
							onChange={(e) => setPhoneNumber(e.target.value)}
							type="tel"
							placeholder="Телефон номер"
						/>
					</div>
				</div>

				<div className="flex items-center justify-between gap-5 flex-col sm:flex-row w-full">
					<AntButton
						loading={isLoading}
						className="h-10 bg-red-500 text-white py-2 px-4 rounded-md w-full sm:w-[100px]"
						onClick={onClose}
					>
						Нет
					</AntButton>

					<AntButton
						loading={isLoading}
						className={
							'h-10 bg-[#0A4D68] text-white py-2 px-4 rounded-md w-full sm:w-[100px]'
						}
						disabled={!pinfl}
						onClick={handleCreate}
					>
						Да
					</AntButton>
				</div>
			</div>
			<ErrorModal getRef={(r) => (errorModalRef.current = r)} />
		</Modal>
	)
}

export default CreateBlackListUser
